export default __webpack_public_path__ + "5a8598a408130f8a0837cc5c07764c11.svg";